import React, { Component } from 'react'
import { observer } from 'mobx-react'
import styles from './style.module.less'
@observer
export default class extends Component {
  render() {
    const { store } = this.props
    const {
      video,
      choose_list,
      barleft,
      barMouseDown,
      barMouseMove,
      barMouseUp,
      barMouseClick
    } = store
    return (
      <div className={styles.clipModal}>
        <video id="video" className={styles.video} src={video} />
        <div className={styles.choose} draggable={false}>
          <ul
            onMouseMove={barMouseMove}
            onClick={barMouseClick}
            onMouseDown={barMouseDown}
            onMouseUp={barMouseUp}
            draggable={false}
          >
            {choose_list.map((img, index) => {
              return (
                <li key={index} draggable={false}>
                  <img draggable={false} src={img} />
                </li>
              )
            })}
            <li id="bar" style={{ left: barleft }} className={styles.bar} />
          </ul>
        </div>
      </div>
    )
  }
}
